/**
 * Keyset paging held in component state, never in a query key or the URL
 * (mission 6 WP08; NFR-005, C-006; research §1.8; contracts/ui-api.md
 * "Paging"). The stack holds the cursors of the pages before the current one,
 * so Previous is served from the cache and the DOM holds one page of at most
 * 50. A change of `scope` (the tab, the severity, the drawer's segment) starts
 * again at the first page in the same render, so no request is ever made with
 * a cursor from another scope.
 */
import { useState } from 'react'

export interface CursorStack {
  /** The cursor of the current page; undefined on the first page. */
  cursor: string | undefined
  /** The 0-based page index. */
  index: number
  next(cursor: string): void
  previous(): void
  reset(): void
}

export function useCursorStack(scope: string): CursorStack {
  const [state, setState] = useState<{ scope: string; stack: string[] }>({ scope, stack: [] })
  const stack = state.scope === scope ? state.stack : []
  return {
    cursor: stack.at(-1),
    index: stack.length,
    next: (cursor) => setState({ scope, stack: [...stack, cursor] }),
    previous: () => setState({ scope, stack: stack.slice(0, -1) }),
    reset: () => setState({ scope, stack: [] }),
  }
}
